const defaultTitle = `Computer Science College for the 21st Century`;
const defaultOgTitle = `A Purpose-Driven College Moving At the Speed of Tech`;
const defaultOgDescription = `Earn your Bachelor’s Degree in Applied Computer Science in 2.5 years, complete with a liberal arts education that prepares you to work with the world’s leading tech companies.`;
const defaultOgImage =
  'https://res.cloudinary.com/makeschool/image/upload/c_fill,g_auto:faces,h_627,w_1200,y_0/v1607092569/MetaImages/hero.jpg';

module.exports = {defaultTitle, defaultOgTitle, defaultOgDescription, defaultOgImage};
